<template>
    <div>
        <form class="form-horizontal" v-if="plano_internet">

            <div class="panel panel-info">
                <!-- Default panel contents -->
                <div class="panel-heading">
                    <i class="fa fa-info-circle" aria-hidden="true"></i> DADOS BÁSICOS
                </div>
                <div class="panel-body">
                    <div class="form-group">

                        <div class="col-sm-8">
                            <label class="control-label">NOME DO PLANOS DE INTERNET</label>
                            <input :disabled="user.level >= 5" type="text" v-model="plano_internet.nome" class="form-control" >
                        </div>

                        <div class="col-sm-2">
                            <label class="control-label">MEGAS</label>
                            <input type="text" v-model.number="plano_internet.megas" class="form-control" >
                        </div>

                        <div class="col-sm-2">
                            <label class="control-label">VALOR</label>
                            <input type="text" v-model.number="plano_internet.valor" class="form-control" >
                        </div>

                    </div>
                </div>
            </div>

            <div class="form-group">
                <div class="col-sm-10">
                    <button type="button" v-if="user.level < 5"
                            @click="save()"
                            class="btn btn-success">
                        <i class="fa fa-floppy-o" aria-hidden="true"></i> SALVAR PLANOS DE INTERNET
                    </button>
                </div>
            </div>

        </form>
    </div>
</template>
<script>
import { PlanoInternet } from "../../../class/index";
import planos_internetComputedMixin from "../../mixins/planos_internet_computed";

export default {
    beforeMount() {
        this.user = this.$store.state.user;
    },
    mixins: [planos_internetComputedMixin],
    data() {
        return {
            user: null
        };
    },
    beforeDestroy() {
        console.log("ponto off");
    },
    methods: {
        save() {
            swal.queue([
                {
                    title: "SALVAR",
                    confirmButtonText: "Salvar",
                    text: "Posso salvar o plano de contas?",
                    showCancelButton: true,
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return new Promise(resolve => {
                            PlanoInternet.save(this.plano_internet)
                                .then(() => {
                                    resolve();
                                    this.$router.push({
                                        path: "/planos-internet"
                                    });
                                })
                                .catch(err => {
                                    console.log(err);
                                    resolve();
                                });
                        });
                    }
                }
            ]);
        }
    }
};
</script>
